
 
import NotificationService from './NotificationService';

export default class ParsMonth {
    static createdInstance = null;
    static getInstance() {
        if (ParsMonth.createdInstance === null) {
            ParsMonth.createdInstance = new ParsMonth();
        }
        return ParsMonth.createdInstance;
    }

    manth = [
        {
          "dictionariesID": 492,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Styczeń",
          "valueID": 1,
          "valueText": "I",
          "orderPosition": 1,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 493,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Luty",
          "valueID": 2,
          "valueText": "II",
          "orderPosition": 2,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 494,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Marzec",
          "valueID": 3,
          "valueText": "III",
          "orderPosition": 3,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 495,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Kwiecień",
          "valueID": 4,
          "valueText": "IV",
          "orderPosition": 4,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 496,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Maj",
          "valueID": 5,
          "valueText": "V",
          "orderPosition": 5,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 497,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Czerwiec",
          "valueID": 6,
          "valueText": "VI",
          "orderPosition": 6,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 498,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Lipiec",
          "valueID": 7,
          "valueText": "VII",
          "orderPosition": 7,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 499,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Sierpień",
          "valueID": 8,
          "valueText": "VIII",
          "orderPosition": 8,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 500,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Wrzesień",
          "valueID": 9,
          "valueText": "IX",
          "orderPosition": 9,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 501,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Październik",
          "valueID": 10,
          "valueText": "X",
          "orderPosition": 10,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 502,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Listopad",
          "valueID": 11,
          "valueText": "XI",
          "orderPosition": 11,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        },
        {
          "dictionariesID": 503,
          "parent_DictionariesID": 491,
          "dictionaryName": "monthName",
          "parent_valueID": 89,
          "name": "Grudzień",
          "valueID": 12,
          "valueText": "XII",
          "orderPosition": 12,
          "description": "",
          "editable": 1,
          "cancelled": 0,
          "whenInserted": "2020-10-26 16:17:43",
          "whoInserted_UsersID": 0,
          "whenUpdated": "2020-10-26 16:17:43",
          "whoUpdated_UsersID": 0,
          "itemColor": "",
          "hidden": 0
        }
      ]

    constructor() {
 
    }

   
}



 
  

 